import {
    apiInformacionComplementariaCertificaciones,
    apiInformacionComplementariaDiasPago,
    apiInformacionComplementariaRangoPrecio,
    apiInformacionComplementariaSectorProveedor,
    apiInformacionComplementariaTipoMonedas,
} from "../settings/apiConfig";
import { createContext, useContext, useEffect, useState } from "react";
import {
    fnHandleChangeChek,
    fnHandleChangeText,
    fnHandleChangeTextNotError,
    fnHandleChangeTextUpper,
    fnHandleChangeUInteger,
} from "../settings/handleConfig";
import { getInformacionComplementariaForm, getPrincipalesForm } from "../model/informacionComplementaria";

import { enumProveedorStep } from "../settings/enumConfig";
import { useProveedoresProspectos } from "./ProveedoresProspectosContext";
import { useRequest } from "./RequestContext";

export const InformacionComplementariaContext = createContext();

export const InformacionComplementariaProvider = (props) => {
    const { Get } = useRequest();
    const { provedoresSteps, entSolicitudDetalleForEdit, handleChangeProveedoresStep,
        handleChangeStep, handleClickResetStepError, Extranjero } = useProveedoresProspectos();

    const [listaTipoMonedas, setListaTipoMonedas] = useState([]);
    const [listaCertificaciones, setListaCertificaciones] = useState([]);
    const [listaDiasPago, setListaDiasPago] = useState([]);
    const [listaRangoPrecio, setListaRangoPrecio] = useState([]);
    const [listaSectorProveedor, setListaSectorProveedor] = useState([]);

    const [principalProveedorForm1, setPrincipalProveedorForm1] = useState(getPrincipalesForm());
    const [principalProveedorForm2, setPrincipalProveedorForm2] = useState(getPrincipalesForm());
    const [principalProveedorForm3, setPrincipalProveedorForm3] = useState(getPrincipalesForm());

    principalProveedorForm1.txtRazonSocialEmpresa.required = false;
    principalProveedorForm1.txtTipoServicioSuministra.required = false;
    principalProveedorForm2.txtRazonSocialEmpresa.required = false;
    principalProveedorForm2.txtTipoServicioSuministra.required = false;
    principalProveedorForm3.txtRazonSocialEmpresa.required = false;
    principalProveedorForm3.txtTipoServicioSuministra.required = false;

    const [principalClienteForm1, setPrincipalClienteForm1] = useState(getPrincipalesForm());
    const [principalClienteForm2, setPrincipalClienteForm2] = useState(getPrincipalesForm());
    const [principalClienteForm3, setPrincipalClienteForm3] = useState(getPrincipalesForm());
    const [informacionComplementariaForm, setInformacionComplementariaForm] = useState(getInformacionComplementariaForm());

    const [otrosCertificados, setOtrosCertificados] = useState(false);
    const [otrosSectores, setOtrosSectores] = useState(false);
    const [errorSectores, setErrorSectores] = useState(false);
    const [entInformacionComplementaria, setEntInformacionComplementaria] = useState(null);
    const [informacionEdicionCargada, setInformacionEdicionCargada] = useState(false);
    const [porcentajeSectorEnfocado, setPorcentajeSectorEnfocado] = useState(false);
    const [porcentajeSectorConfirmado, setPorcentajeSectorEnfocadoConfirmado] = useState(false);
    const [modalOpenPorcentajeSectorNoEnfocado, setModalOpenPorcentajeSectorNoEnfocado] = useState(false);

    const handleChangePrincipalProveedor1 = fnHandleChangeTextUpper(principalProveedorForm1, setPrincipalProveedorForm1);
    const handleChangePrincipalProveedor2 = fnHandleChangeTextUpper(principalProveedorForm2, setPrincipalProveedorForm2);
    const handleChangePrincipalProveedor3 = fnHandleChangeTextUpper(principalProveedorForm3, setPrincipalProveedorForm3);
    const handleChangePrincipalCliente1 = fnHandleChangeTextUpper(principalClienteForm1, setPrincipalClienteForm1);
    const handleChangePrincipalCliente2 = fnHandleChangeTextUpper(principalClienteForm2, setPrincipalClienteForm2);
    const handleChangePrincipalCliente3 = fnHandleChangeTextUpper(principalClienteForm3, setPrincipalClienteForm3);
    const handleChangeInfCompText = fnHandleChangeText(informacionComplementariaForm, setInformacionComplementariaForm);
    const handleChangeInfCompUInt = fnHandleChangeUInteger(informacionComplementariaForm, setInformacionComplementariaForm);
    const handleChangeInfCompNoError = fnHandleChangeTextNotError(informacionComplementariaForm, setInformacionComplementariaForm);
    const handleChangeInfCompCheck = fnHandleChangeChek(informacionComplementariaForm, setInformacionComplementariaForm);

    const handleClickSeleccionarCertificado = (iIdCertificacion) => (e) => {
        setListaCertificaciones(
            listaCertificaciones.map((x) => ({ ...x, bCheck: x.iIdCertificacion === iIdCertificacion ? e.target.checked : x.bCheck }))
        );
    };

    const handleClickSeleccionarSector = (iSectorProveedor) => (e) => {
        setListaSectorProveedor(
            listaSectorProveedor.map((x) => ({ ...x, bCheck: x.iSectorProveedor === iSectorProveedor ? e.target.checked : x.bCheck }))
        );
        setErrorSectores(false);
    };

    const handleClosePorcentajeSectorNoEnfocado = () => {
        setModalOpenPorcentajeSectorNoEnfocado(false);
    };

    const handleClickConfirmarContinuarSinPorcenrajeSectorEnfocado = () => {
        setModalOpenPorcentajeSectorNoEnfocado(false);
        setPorcentajeSectorEnfocado(true);
        setPorcentajeSectorEnfocadoConfirmado(true);
    };

    const handleChangeSlidePrivado = (e, value) => {
        const { txtPorcentajeParticipacionSectorPrivado } = informacionComplementariaForm;

        setInformacionComplementariaForm({
            ...informacionComplementariaForm,
            txtPorcentajeParticipacionSectorPrivado: {
                ...txtPorcentajeParticipacionSectorPrivado,
                value,
            },
        });

        if (!porcentajeSectorConfirmado) {
            setPorcentajeSectorEnfocado(true);
        }
    };

    const handleChangeSlideGobierno = (e, value) => {
        const { txtPorcentajeParticipacionSectorGobierno } = informacionComplementariaForm;

        setInformacionComplementariaForm({
            ...informacionComplementariaForm,
            txtPorcentajeParticipacionSectorGobierno: {
                ...txtPorcentajeParticipacionSectorGobierno,
                value,
            },
        });
        if (!porcentajeSectorConfirmado) {
            setPorcentajeSectorEnfocado(true);
        }
    };

    const handleClickOtrosCertificados = (e) => {
        setOtrosCertificados(e.target.checked);
    };

    const handleClickOtrosSectores = (e) => {
        setOtrosSectores(e.target.checked);
    };

    const handleClickRegresar = () => {
        handleChangeStep(enumProveedorStep.DomicilioFiscal);
    };

    const handleClickDeleteChipMoneda = (moneda) => {
        const { txtMonedaFacturacion } = informacionComplementariaForm;

        setInformacionComplementariaForm({
            ...informacionComplementariaForm,
            txtMonedaFacturacion: {
                ...txtMonedaFacturacion,
                value: txtMonedaFacturacion.value.filter((x) => x.iIdMonedas !== moneda.iIdMonedas),
            },
        });
    };

    const fnGetProveedorPrincipalValues = (id, form) => {
        const { txtRazonSocialEmpresa, txtTipoServicioSuministra } = form;

        return {
            iIdPrincipal: id,
            sRazonSocial: txtRazonSocialEmpresa.value,
            sTipoServicio: txtTipoServicioSuministra.value,
        };
    };

    const fnGetProveedorClientesValues = (id, form) => {
        const { txtRazonSocialEmpresa, txtTipoServicioSuministra } = form;

        return {
            iIdCliente: id,
            sRazonSocial: txtRazonSocialEmpresa.value,
            sTipoServicio: txtTipoServicioSuministra.value,
        };
    };

    const handleClickSiguiente = () => {
        const proveedoresErrors = [
            //handleClickValidarErrorProveedorPrincipal(principalProveedorForm1, setPrincipalProveedorForm1),
            // handleClickValidarErrorProveedorPrincipal(principalProveedorForm2, setPrincipalProveedorForm2),
            // handleClickValidarErrorProveedorPrincipal(principalProveedorForm3, setPrincipalProveedorForm3),
            handleClickValidarErrorProveedorPrincipal(principalClienteForm1, setPrincipalClienteForm1),
            handleClickValidarErrorProveedorPrincipal(principalClienteForm2, setPrincipalClienteForm2),
            handleClickValidarErrorProveedorPrincipal(principalClienteForm3, setPrincipalClienteForm3),
        ];

        const {
            txtCondicionPago,
            txtMonedaFacturacion,
            txtNumeroTotalClientes,
            txtOtrosCertificados,
            txtRangoIngresosAnuales,
            txtOtrosSectoresProveedor,
            txtPorcentajeParticipacionSectorPrivado,
            txtPorcentajeParticipacionSectorGobierno,
        } = informacionComplementariaForm;

        const tempForm = {
            ...informacionComplementariaForm,
            txtOtrosCertificados: {
                ...txtOtrosCertificados,
                error: otrosCertificados && txtOtrosCertificados.value === "",
            },
            txtMonedaFacturacion: {
                ...txtMonedaFacturacion,
                error: txtMonedaFacturacion.value.length === 0,
            },
            txtCondicionPago: {
                ...txtCondicionPago,
                error: txtCondicionPago.value === "",
            },
            txtNumeroTotalClientes: {
                ...txtNumeroTotalClientes,
                error: txtNumeroTotalClientes.value === "",
            },
            txtRangoIngresosAnuales: {
                ...txtRangoIngresosAnuales,
                error: txtRangoIngresosAnuales.value === "",
            },
            txtOtrosSectoresProveedor: {
                ...txtOtrosSectoresProveedor,
                error: otrosSectores && txtOtrosSectoresProveedor.value === "",
            },
        };

        setInformacionComplementariaForm(tempForm);

        const errorSectoresTemp = listaSectorProveedor.filter((x) => x.bCheck).length === 0;

        setErrorSectores(errorSectoresTemp);

        if (
            Object.values(tempForm)
                .map((x) => x.error)
                .includes(true) ||
            proveedoresErrors.includes(true) ||
            errorSectoresTemp
        ) {
            handleChangeProveedoresStep(
                provedoresSteps.map((x) => ({ ...x, error: x.id === enumProveedorStep.InformacionComplementaria ? true : false }))
            );
            return;
        } else {
            handleClickResetStepError();
        }

        if (!porcentajeSectorEnfocado) {
            setModalOpenPorcentajeSectorNoEnfocado(true);
            return;
        }

        const entInformacionComplementariaTemp = {
            lstPrincipalesProveedores: [
                fnGetProveedorPrincipalValues(1, principalProveedorForm1),
                fnGetProveedorPrincipalValues(2, principalProveedorForm2),
                fnGetProveedorPrincipalValues(3, principalProveedorForm3),
            ],
            lstClientesReferencia: [
                fnGetProveedorClientesValues(1, principalClienteForm1),
                fnGetProveedorClientesValues(2, principalClienteForm2),
                fnGetProveedorClientesValues(3, principalClienteForm3),
            ],
            lstCertificaciones: listaCertificaciones.filter((x) => x.bCheck),
            sOtrosCertificados: txtOtrosCertificados.value,
            lstMonedasFacturacion: txtMonedaFacturacion.value,
            iCondicionPago: parseInt(txtCondicionPago.value),
            iNumeroTotalClientes: parseInt(txtNumeroTotalClientes.value),
            iPorcentajeParticipacionPrivado: parseInt(txtPorcentajeParticipacionSectorPrivado.value),
            iPorcentajeParticipacionGobierno: parseInt(txtPorcentajeParticipacionSectorGobierno.value),
            iRangoPrecio: parseInt(txtRangoIngresosAnuales.value),
            lstSectores: listaSectorProveedor.filter((x) => x.bCheck),
            sOtrosSectores: txtOtrosSectoresProveedor.value,
        };

        setEntInformacionComplementaria(entInformacionComplementariaTemp);

        handleChangeStep(enumProveedorStep.EnviarSolicitud);
    };

    const handleClickValidarErrorProveedorPrincipal = (form, setForm) => {
        const { txtRazonSocialEmpresa, txtTipoServicioSuministra } = form;

        const tempForm = {
            ...form,
            txtRazonSocialEmpresa: {
                ...txtRazonSocialEmpresa,
                error: txtRazonSocialEmpresa.value === "",
            },
            txtTipoServicioSuministra: {
                ...txtTipoServicioSuministra,
                error: txtTipoServicioSuministra.value === "",
            },
        };

        setForm(tempForm);

        if (
            Object.values(tempForm)
                .map((x) => x.error)
                .includes(true)
        ) {
            return true;
        } else {
            return false;
        }
    };

    const handleClickGetTipoMonedas = async () => {
        const response = await CGetMonedas();
        if (response.Code === 0) {
            setListaTipoMonedas(response.Result);
        } else {
            setListaTipoMonedas([]);
        }
    };

    const handleClickGetCertificaciones = async () => {
        const response = await CGetCertificaciones();
        if (response.Code === 0) {
            setListaCertificaciones(response.Result);
        } else {
            setListaCertificaciones([]);
        }
    };

    const handleClickGetDiasPago = async () => {
        const response = await CGetDiasPago();
        if (response.Code === 0) {
            setListaDiasPago(response.Result);
        } else {
            setListaDiasPago([]);
        }
    };

    const handleClickGetRangoPrecio = async () => {
        const response = await CGetRangoPrecio();
        if (response.Code === 0) {
            setListaRangoPrecio(response.Result);
        } else {
            setListaRangoPrecio([]);
        }
    };

    const handleClickGetSectorProveedor = async () => {
        const response = await CGetSectorProveedor();
        if (response.Code === 0) {
            setListaSectorProveedor(response.Result);
        } else {
            setListaSectorProveedor([]);
        }
    };

    const CGetMonedas = async () => {
        const payload = {
            url: apiInformacionComplementariaTipoMonedas,
        };

        return await Get(payload);
    };

    const CGetCertificaciones = async () => {
        const payload = {
            url: apiInformacionComplementariaCertificaciones,
        };

        return await Get(payload);
    };

    const CGetDiasPago = async () => {
        const payload = {
            url: apiInformacionComplementariaDiasPago,
        };

        return await Get(payload);
    };

    const CGetRangoPrecio = async () => {
        const payload = {
            url: apiInformacionComplementariaRangoPrecio,
        };

        return await Get(payload);
    };

    const CGetSectorProveedor = async () => {
        const payload = {
            url: apiInformacionComplementariaSectorProveedor,
        };

        return await Get(payload);
    };

    const fnSetProveedorPrincipal = (form, setForm, obj) => {
        const { txtRazonSocialEmpresa, txtTipoServicioSuministra } = form;
        const { sRazonSocial, sTipoServicio } = obj;

        setForm({
            ...form,
            txtRazonSocialEmpresa: { ...txtRazonSocialEmpresa, value: !sRazonSocial ? "" : sRazonSocial },
            txtTipoServicioSuministra: { ...txtTipoServicioSuministra, value: !sTipoServicio ? "" : sTipoServicio },
        });
    };

    const fnFillFormInformacionComplementaria = () => {
        const {
            entInformacionComplementaria: {
                lstPrincipalesProveedores: [proveedor1, proveedor2, proveedor3],
                lstClientesReferencia: [cliente1, cliente2, cliente3],
                lstCertificaciones,
                sOtrosCertificados,
                lstMonedasFacturacion,
                iCondicionPago,
                iNumeroTotalClientes,
                iPorcentajeParticipacionPrivado,
                iPorcentajeParticipacionGobierno,
                iRangoPrecio,
                lstSectores,
                sOtrosSectores,
            },
        } = entSolicitudDetalleForEdit;

        fnSetProveedorPrincipal(principalProveedorForm1, setPrincipalProveedorForm1, proveedor1);
        fnSetProveedorPrincipal(principalProveedorForm2, setPrincipalProveedorForm2, proveedor2);
        fnSetProveedorPrincipal(principalProveedorForm3, setPrincipalProveedorForm3, proveedor3);
        fnSetProveedorPrincipal(principalClienteForm1, setPrincipalClienteForm1, cliente1);
        fnSetProveedorPrincipal(principalClienteForm2, setPrincipalClienteForm2, cliente2);
        fnSetProveedorPrincipal(principalClienteForm3, setPrincipalClienteForm3, cliente3);

        const lstMonedasFacturacionIDCurrent = lstMonedasFacturacion.map((x) => x.iIdMonedas);
        const modenasSeleccionadas = listaTipoMonedas.filter((x) => lstMonedasFacturacionIDCurrent.includes(x.iIdMonedas));

        const {
            txtCondicionPago,
            txtMonedaFacturacion,
            txtNumeroTotalClientes,
            txtOtrosCertificados,
            txtRangoIngresosAnuales,
            txtOtrosSectoresProveedor,
            txtPorcentajeParticipacionSectorPrivado,
            txtPorcentajeParticipacionSectorGobierno,
        } = informacionComplementariaForm;

        setInformacionComplementariaForm({
            ...informacionComplementariaForm,
            txtCondicionPago: { ...txtCondicionPago, value: !iCondicionPago ? "" : iCondicionPago.toString() },
            txtMonedaFacturacion: { ...txtMonedaFacturacion, value: !lstMonedasFacturacion ? [] : modenasSeleccionadas },
            txtNumeroTotalClientes: { ...txtNumeroTotalClientes, value: !iNumeroTotalClientes ? "" : iNumeroTotalClientes.toString() },
            txtOtrosCertificados: { ...txtOtrosCertificados, value: !sOtrosCertificados ? "" : sOtrosCertificados },
            txtRangoIngresosAnuales: { ...txtRangoIngresosAnuales, value: !iRangoPrecio ? "" : iRangoPrecio.toString() },
            txtOtrosSectoresProveedor: { ...txtOtrosSectoresProveedor, value: !sOtrosSectores ? "" : sOtrosSectores },
            txtPorcentajeParticipacionSectorPrivado: {
                ...txtPorcentajeParticipacionSectorPrivado,
                value: !iPorcentajeParticipacionPrivado ? "" : iPorcentajeParticipacionPrivado.toString(),
            },
            txtPorcentajeParticipacionSectorGobierno: {
                ...txtPorcentajeParticipacionSectorGobierno,
                value: !iPorcentajeParticipacionGobierno ? "" : iPorcentajeParticipacionGobierno.toString(),
            },
        });

        const lstCertificacionesID = lstCertificaciones.map((x) => x.iIdCertificacion);
        setListaCertificaciones(
            listaCertificaciones.map((x) => ({
                ...x,
                bCheck: lstCertificacionesID.includes(x.iIdCertificacion),
            }))
        );

        const lstSectoresID = lstSectores.map((x) => x.iSectorProveedor);
        setListaSectorProveedor(
            listaSectorProveedor.map((x) => ({
                ...x,
                bCheck: lstSectoresID.includes(x.iSectorProveedor),
            }))
        );

        setOtrosCertificados(!!sOtrosCertificados && sOtrosCertificados !== "");
        setOtrosSectores(!!sOtrosSectores && sOtrosSectores !== "");
        setInformacionEdicionCargada(true);
    };

    useEffect(() => {
        if (
            entSolicitudDetalleForEdit &&
            listaCertificaciones.length > 0 &&
            listaSectorProveedor.length > 0 &&
            !informacionEdicionCargada
        ) {
            fnFillFormInformacionComplementaria();
        }
        // eslint-disable-next-line
    }, [entSolicitudDetalleForEdit, listaCertificaciones, listaSectorProveedor, informacionEdicionCargada]);

    useEffect(() => {
        handleClickGetTipoMonedas();
        handleClickGetCertificaciones();
        handleClickGetDiasPago();
        handleClickGetRangoPrecio();
        handleClickGetSectorProveedor();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (porcentajeSectorEnfocado && porcentajeSectorConfirmado) {
            handleClickSiguiente();
        }
        // eslint-disable-next-line
    }, [porcentajeSectorEnfocado, porcentajeSectorConfirmado]);

    return (
        <InformacionComplementariaContext.Provider
            value={{
                listaTipoMonedas,
                listaCertificaciones,
                listaDiasPago,
                listaRangoPrecio,
                listaSectorProveedor,
                principalProveedorForm1,
                principalProveedorForm2,
                principalProveedorForm3,
                principalClienteForm1,
                principalClienteForm2,
                principalClienteForm3,
                informacionComplementariaForm,
                otrosCertificados,
                Extranjero,
                otrosSectores,
                errorSectores,
                entInformacionComplementaria,
                porcentajeSectorEnfocado,
                modalOpenPorcentajeSectorNoEnfocado,
                handleClosePorcentajeSectorNoEnfocado,
                handleClickConfirmarContinuarSinPorcenrajeSectorEnfocado,
                handleChangePrincipalProveedor1,
                handleChangePrincipalProveedor2,
                handleChangePrincipalProveedor3,
                handleChangePrincipalCliente1,
                handleChangePrincipalCliente2,
                handleChangePrincipalCliente3,
                handleChangeInfCompText,
                handleChangeInfCompUInt,
                handleChangeInfCompNoError,
                handleChangeInfCompCheck,
                handleClickSeleccionarCertificado,
                handleClickSeleccionarSector,
                handleClickOtrosCertificados,
                handleClickOtrosSectores,
                handleChangeSlidePrivado,
                handleChangeSlideGobierno,
                handleClickRegresar,
                handleClickSiguiente,
                handleClickDeleteChipMoneda,
            }}
        >
            {props.children}
        </InformacionComplementariaContext.Provider>
    );
};

export const useInformacionComplementaria = function () {
    return useContext(InformacionComplementariaContext);
};
